const GA4_PREFIX = 'G-';

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>;
  }
}

export interface IAnalylticsServiceConfig {
  id: string;
}

export interface IAnalylticsService {
  config: IAnalylticsServiceConfig;
  SIGNUP: string;
  LOGIN: string;
  FAIL: string;
  initAnalytics(googleAnalyticsId: string): void;
  signUp(): void;
  fail(errorDetails: { label: string; value: string }): void;
}

export class AnalyticsService {
  public static readonly SIGNUP = 'sign_up';
  public static readonly LOGIN = 'login';
  public static readonly SIGNUP_FAIL = 'signup_fail';
  public static readonly LOGIN_FAIL = 'login_fail';

  private ensureDataLayer() {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      return true;
    }
    return false;
  }

  initAnalytics(googleAnalyticsId: string) {
    this._initGA4(googleAnalyticsId);
  }

  private _initGA4(googleAnalyticsId: string) {
    const isGA4PrefixMissing = !googleAnalyticsId?.startsWith(GA4_PREFIX);
    if (isGA4PrefixMissing) {
      googleAnalyticsId = GA4_PREFIX + googleAnalyticsId;
    }
    // This is a stub - you could insert GA4 script here if needed
  }

  signUp(params?: Record<string, unknown>) {
    if (this.ensureDataLayer()) {
      window.dataLayer.push({
        event: AnalyticsService.SIGNUP,
        ...params,
      });
    }
  }

  login(params?: Record<string, unknown>) {
    if (this.ensureDataLayer()) {
      window.dataLayer.push({
        event: AnalyticsService.LOGIN,
        ...params,
      });
    }
  }

  signupFail(errorDetails: { label: string; value: string }) {
    if (this.ensureDataLayer()) {
      window.dataLayer.push({
        event: AnalyticsService.SIGNUP_FAIL,
        errorDetails,
      });
    }
  }

  loginFail(errorDetails: { label: string; value: string }) {
    if (this.ensureDataLayer()) {
      window.dataLayer.push({
        event: AnalyticsService.LOGIN_FAIL,
        errorDetails,
      });
    }
  }

  static defaultConfig() {
    return {
      id: process.env.NEXT_PUBLIC_GTAG as string,
    };
  }
}

export const analyticsService = new AnalyticsService();
